module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/vitrins-82c5aba63f567129039187a6fef1a892.png";